import { render } from "./AddOutletView.vue?vue&type=template&id=b5d00440"
import script from "./AddOutletView.vue?vue&type=script&lang=js"
export * from "./AddOutletView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\WORK\\Tamani\\admin-landing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__